import { https } from "../http";
import store from "../store";


import { setAddPayerLoading, setAllListPayer, setAllPayer, setLoading } from "../store/reducers/payer";
import { showError } from "../utils/index";



// POST
const createpayer = async (data, callback) => {
    try {
      store.dispatch(setAddPayerLoading(true));
      let response = await https().post("payer", data);
  
      if (response?.status === 200) {
       // getReports(false);
        callback?.();
      }

      return response

    } catch (error) {
      store.dispatch(setAddPayerLoading(false));
      showError(error?.response?.data?.message, error?.response?.status);
    }
  };





// get
  
  const getpayer = async ( payload,showLoading = true) => {
    try {
      if (showLoading) store.dispatch(setLoading(true));
      // let response = await https().get(`payer/${
      //   payload && payload.page ? `${payload.page}` : 'all'
      // }`);


          let response = await https().get(
            `payer/${payload && payload.page ? `${payload.page}` : "all"}${
              payload && payload.name ? `?name=${payload.name}` : ""
            }`
          );
  
      if (response?.status === 200) {



        store.dispatch(setAllPayer(response?.data));
      }
    } catch (error) {
      store.dispatch(setLoading(false));
      showError(error?.response?.data?.message, error?.response?.status)
    }
  };


  // get payerlist


  const getpayerlist = async ( name,showLoading = true) => {
    try {
      if (showLoading) store.dispatch(setLoading(true));
      let response = await https().get(`payer/list-payer/list${name ? `?name=${name}` : ''}`);
  
      if (response?.status === 200) {



         store.dispatch(setAllListPayer(response?.data));
      }
    } catch (error) {
      store.dispatch(setLoading(false));
      showError(error?.response?.data?.message, error?.response?.status)
    }
  };


  // put

  const editPayer = async (data, showLoading = true) => {
    try {
      store.dispatch(setAddPayerLoading(true));
      let response = await https().put(`/payer/${data?.id}`, data);
  
      if (response?.status === 200) {
        getpayer(showLoading);
       
      }
  
      return response
    } catch (error) {
      store.dispatch(setAddPayerLoading(false));
      showError(error?.response?.data?.message, error?.response?.status)
    }
  };


  // delete

  const removepayer = async (data, showLoading = true) => {
    try {
      store.dispatch(setAddPayerLoading(true));
  
      // console.log('data',data);
  
      let response = await https().delete(
        `/payer/${data?.id}`
      );
  
      if (response?.status === 200) {
        getpayer(showLoading);
      }
  
      return response;
    } catch (error) {
      store.dispatch(setAddPayerLoading(false));
      showError(error?.response?.data?.message, error?.response?.status);
    }
  };
  


  export {createpayer,getpayer,editPayer,getpayerlist,removepayer}

